import {pullRequestsAppBuilder} from '../config/app-builder'
import {FindingsRoutePath} from './route-paths'

export const pullRequestsFindingsRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsFindingsRoute', {
  path: FindingsRoutePath,
  queries: [],
})
